import { render, staticRenderFns } from "./userAttList.vue?vue&type=template&id=1152e1da&scoped=true"
import script from "./userAttList.vue?vue&type=script&lang=js"
export * from "./userAttList.vue?vue&type=script&lang=js"
import style0 from "./userAttList.vue?vue&type=style&index=0&id=1152e1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152e1da",
  null
  
)

export default component.exports